// Random heights and widths
export const ADDITIONAL_LEGEND_HEIGHT = 23;
export const BASE_LEGEND_HEIGHT = 37;

// Chart dash styles
export const ANNOTATION_DASH_STYLE = 'Dash';
export const ESTIMATE_DASH_STYLE = 'Dot';

// Chart arrow
export const CHART_ARROW_HEIGHT = 16.5;
export const CHART_ARROW_PATH = ['M0', '8', 'L8', '0', 'L50', '0', 'L50', '16', 'L8', '16', 'Z'];
export const MIN_CHART_ARROW_WIDTH = 42;


// Time related
export const MULTI_YEAR_THRESHOLD = 3.5;
export const MULTI_MONTH_THRESHOLD = 2.5;
export const TIME_UNIT_SIZE = {
    second: 1000,
    minute: 60 * 1000,
    hour: 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    month: 30 * 24 * 60 * 60 * 1000,
    year: 365.2425 * 24 * 60 * 60 * 1000,
};

// Tooltip styles
export const TOOLTIP_STYLE_BAR = 'bar';
export const TOOLTIP_STYLE_BOX = 'box';

// Chart scale types
export const SCALE_TYPE_LINEAR = 'linear';
export const SCALE_TYPE_LOG = 'log';

// Chart data formatting options
export const CHART_FORMAT_CURRENCY_GROWTH = 'currency_growth';
export const CHART_FORMAT_NORMALIZED = 'indexed';
export const CHART_FORMAT_PERCENT_OFF_HIGH = 'percent_off_high';
export const CHART_FORMAT_REAL = 'real';

// Annotations
export const ANNOTATION_AVG = 'avg';
export const ANNOTATION_DIVIDENDS = 'dividends';
export const ANNOTATION_EARNINGS_RESULTS = 'earnings_results';
export const ANNOTATION_FORCE_ORIGINAL = 'force_original';
export const ANNOTATION_LINE_COLOR = 'line_color';
export const ANNOTATION_LINE_WEIGHT = 'line_weight';
export const ANNOTATION_MAX = 'max';
export const ANNOTATION_MIN = 'min';
export const ANNOTATION_SPINOFFS = 'spinoffs';
export const ANNOTATION_SPLITS = 'splits';

export const SERIES_TYPE_FLAGS = 'flags';
export const ANNOTATION_FLAG_TITLE_MAP = {
    [ANNOTATION_DIVIDENDS]: 'D',
    [ANNOTATION_EARNINGS_RESULTS]: 'E',
    [ANNOTATION_SPLITS]: 'S',
    [ANNOTATION_SPINOFFS]: 'S',
};

export const ANNOTATION_LINE_LABEL_INFO = {
    [ANNOTATION_MIN]: {
        label: {
            prefix: 'Low: ',
            y: 12.5,
        },
        arrow: null,
    },
    [ANNOTATION_MAX]: {
        label: {
            prefix: 'Hi: ',
            y: -10.5,
        },
        arrow: null,
    },
    [ANNOTATION_AVG]: {
        label: null,
        arrow: {
            suffix: 'AVG',
        },
    },
};

// Fund Chart Line Width
export const FUND_CHART_LINE_WEIGHT_THIN = 'thin';
export const FUND_CHART_LINE_WEIGHT_MEDIUM = 'medium';
export const FUND_CHART_LINE_WEIGHT_THICK = 'thick';

export const LINE_WEIGHT_MAPPING = {
    [FUND_CHART_LINE_WEIGHT_THIN]: 1,
    [FUND_CHART_LINE_WEIGHT_MEDIUM]: 2,
    [FUND_CHART_LINE_WEIGHT_THICK]: 4,
};

// Line Width To Label Map
export const LINE_WEIGHT_LABEL_MAP = {
    [FUND_CHART_LINE_WEIGHT_THIN]: 'Thin',
    [FUND_CHART_LINE_WEIGHT_MEDIUM]: 'Medium',
    [FUND_CHART_LINE_WEIGHT_THICK]: 'Thick',
};
